"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

/**
 * n 需要转换的数字，会对万和亿进行简化
 */
function formatNumber(n, thousandsSeparated) {
  var res;

  if (typeof n !== 'number') {
    n = (0, _parseFloat2.default)(n) ? (0, _parseFloat2.default)(n) : 0;
  }

  if (thousandsSeparated) {
    return (n + '').replace(/(?=\B(?:\d{3})+$)/g, ',');
  }

  if (n < 1e4) {
    return n + '';
  }

  if (n < 1e5) {
    res = (n / 1e4).toFixed(1);
    return res.split('.')[1] === '0' ? res.split('.')[0] + '万' : res + '万';
  }

  if (n < 1e8) {
    return Math.floor(n / 1e4) + '万';
  }

  if (n < 1e9) {
    res = (n / 1e8).toFixed(1);
    return res.split('.')[1] === '0' ? res.split('.')[0] + '亿' : res + '亿';
  }

  return Math.floor(n / 1e8) + '亿';
}

formatNumber.default = formatNumber;
var _default = formatNumber;
exports.default = _default;
module.exports = exports["default"];